import { render, staticRenderFns } from "./VscAuthBtn.vue?vue&type=template&id=76bfc28b&"
import script from "./VscAuthBtn.vue?vue&type=script&lang=js&"
export * from "./VscAuthBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/tmp/build_624ab6ba5d034d6f7e958d1dd11cd1de/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
